<template>
  <Biography />
</template>

<script>
import Biography from './pages/Biography.vue'

export default {
  name: 'App',
  components: {
    Biography
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: aqua;
  /* margin-left: 10px; */
}
</style>
